import { AlertCircle } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import {
  buildRemovalResolutionUserMessage,
  type RemovalRunResolutionEntry,
} from '@/lib/removalRunResolutionMessages';

type RemovalRunBlockedBannerProps = {
  failures: RemovalRunResolutionEntry[];
  cycleNameById?: Map<number, string>;
};

export function RemovalRunBlockedBanner({
  failures,
  cycleNameById,
}: RemovalRunBlockedBannerProps) {
  const blockingFailures = failures.filter((entry) => !entry.ok);

  return (
    <Card className="border-amber-300 bg-amber-50" data-testid="removal-run-blocked-banner">
      <CardContent className="flex items-start gap-3 p-4">
        <AlertCircle className="mt-0.5 h-5 w-5 shrink-0 text-amber-700" />
        <div className="space-y-2">
          <p className="font-medium text-amber-900">
            Removal tasks withheld — posting tasks below are still available
          </p>
          {blockingFailures.length > 0 ? (
            <ul className="list-disc space-y-1 pl-5 text-sm text-amber-800">
              {blockingFailures.map((entry) => (
                <li key={`${entry.sourceCycleId}-${entry.targetCycleId}-${entry.status}`}>
                  {buildRemovalResolutionUserMessage(entry, cycleNameById)}
                </li>
              ))}
            </ul>
          ) : (
            <p className="text-sm text-amber-800">
              Removals from the previous cycle could not be loaded safely. Posting tasks below are unaffected.
            </p>
          )}
          <p className="text-sm text-amber-800">
            You can review and dispatch posting assignments. Do not rely on removal rows until this clears.
          </p>
        </div>
      </CardContent>
    </Card>
  );
}
